import React, { useCallback } from 'react';
import { Col, Row } from 'reactstrap';
import { useSelector } from 'react-redux';
import car from 'assets/img/icons/car2.svg';
import auction from 'assets/img/icons/auction2.svg';
import favorite from 'assets/img/icons/favorite2.svg';
import chart from 'assets/img/icons/chart.svg';
import { useLocation, useNavigate } from 'react-router-dom';
import RouterPaths from '../../../constants/RouterPaths';

function DashboardTabs() {
  const navigate = useNavigate();
  const location = useLocation();

  const isActiveRoute = useCallback((route) => route === location.pathname, [location]);
  const roles = {
    buyer: useSelector((state) => state.auth.get('isBuyer')),
    seller: useSelector((state) => state.auth.get('isSeller')),
  };

  return (
    <div className="dashboard-tabs-container">
      <Row className="dashboard-tabs">
        {roles?.seller && (
          <Col className="dashboard-btn-col">
            <button
              type="button"
              onClick={() => navigate(RouterPaths.MY_VEHICLES)}
              className={`${isActiveRoute(RouterPaths.MY_VEHICLES) ? 'active' : ''}`}
            >
              <img src={car} alt="icon" />
              <span>Selling</span>
            </button>
          </Col>
        )}
        {roles?.buyer && (
          <Col className="dashboard-btn-col">
            <button
              type="button"
              onClick={() => navigate(RouterPaths.MY_BIDS)}
              className={`${isActiveRoute(RouterPaths.MY_BIDS) ? 'active' : ''}`}
            >
              <img src={auction} alt="icon" />
              <span>Buying</span>
            </button>
          </Col>
        )}
        <Col className="dashboard-btn-col">
          <button
            type="button"
            onClick={() => navigate(RouterPaths.FAVOURITE_OFFERS)}
            className={`${isActiveRoute(RouterPaths.FAVOURITE_OFFERS) ? 'active' : ''}`}
          >
            <img src={favorite} alt="icon" />
            <span>
              Favourite <span>offers</span>
            </span>
          </button>
        </Col>
        <Col
          className={`dashboard-btn-col ${isActiveRoute(RouterPaths.ANALYTICS) ? 'active' : ''}`}
        >
          <button
            type="button"
            onClick={() => navigate(RouterPaths.ANALYTICS)}
            className={`${isActiveRoute(RouterPaths.ANALYTICS) ? 'active' : ''}`}
          >
            <img src={chart} alt="icon" />
            <span>Analytics</span>
          </button>
        </Col>
      </Row>
    </div>
  );
}

export default DashboardTabs;
